const cookie = require('../utils/cookie.js')
const encoding = require('../utils/encoding.js')
import {$fetch} from '../fetch-api/fetch-api.js'
import {handleError, handleResponse} from '../fetch-api/handle-error.js'

export var $oauth2 = {
  appURL: process.env.VUE_APP_REST_API_BASE_URL + '/ra/api/v1',
  expires: {
    access: null,
    refresh: null
  },
  atenName() {
    return process.env.VUE_APP_NAME.substring(0, 3) + '-aten'
  },
  atpeName() {
    return process.env.VUE_APP_NAME.substring(0, 3) + '-atpe'
  },
  atscName() {
    return process.env.VUE_APP_NAME.substring(0, 3) + '-atsc'
  },
  rtenName(value = 'surikata') {
    return value.substring(0, 3) + '-rten'
  },
  apidName() {
    return process.env.VUE_APP_NAME.substring(0, 3) + '-apid'
  },
  oastName() {
    return process.env.VUE_APP_NAME.substring(0, 3) + '-oast'
  },
  accessToken() {
    return cookie.getValue(this.atenName())
  },
  accessScope() {
    return cookie.getValue(this.atscName())
  },
  refreshToken(value = { path: process.env.BASE_URL }) {
    return cookie.getValue(this.rtenName(), value)
  },
  tokenType() {
    // return 'Bearer'
    return cookie.getValue(this.atpeName())
  },
  hasAccessToken() {
    return this.accessToken() !== undefined
  },
  hasRefreshToken(value) {
    return this.refreshToken(value) !== undefined
  },
  isGuest() {
    return this.accessScope() === undefined || this.accessScope() === 'guest-access'
  },
  getAuthToken(clientId, code, scope, codeChallenge = '', client_secret = '') {
    const body = {
      'grant_type': 'authorization_code',
      'scope': scope,
      'code': code,
      'client_id': clientId,
      'client_secret': client_secret,
      'code_challenge': codeChallenge
    }
    const options = {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'accept': 'application/json; charset=utf-8',
        'content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      body: encoding.encodeComponent(body),
      dataType: 'text'
    }
    return fetch(`${this.appURL}/oauth2/token`, options).then(handleResponse).then(response => {
      return response.json().then(json => {
        this.alertResponse = null
        // nastaveni platnosti tokenu v cookies
        this.expires.access = new Date(new Date().getTime() + json.expires_in * 1000)
        cookie.setValue(this.atenName(), json.access_token, {
          expires: this.expires.access
        })
        cookie.setValue(this.atpeName(), json.token_type, {
          expires: this.expires.access
        })
        cookie.setValue(this.atscName(), scope, {
          expires: this.expires.access
        })
      })
    }).catch(handleError)
  }
}

export function removeRefreshToken(value = { path: process.env.BASE_URL }) {
  if ($oauth2.hasRefreshToken(value)) {
    const options = {
      method: 'DELETE',
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
        'authorization': $oauth2.tokenType() + ' ' + $oauth2.accessToken(),
        'token': $oauth2.refreshToken(value)
      }
    }
    cookie.removeValue($oauth2.rtenName(), value)
    $oauth2.expires.refresh = null
    $oauth2.expires.access = null
    return fetch(`${$oauth2.appURL}/oauth2/token`, options).then(handleResponse).catch(handleError)
  }
}

export function hasRefreshToken() {
  // return $oauth2.hasRefreshToken()
  return false
}

export function removeAccessToken() {
  if ($oauth2.hasAccessToken()) {
    const options = {
      method: 'DELETE',
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
        'authorization': $oauth2.tokenType() + ' ' + $oauth2.accessToken(),
        'token': $oauth2.accessToken()
      }
    }
    cookie.removeValue($oauth2.atenName())
    cookie.removeValue($oauth2.atpeName())
    cookie.removeValue($oauth2.atscName())
    $oauth2.expires.access = null
    return fetch(`${$oauth2.appURL}/oauth2/token`, options).then(handleResponse).catch(handleError)
  }
}

export function hasAccessToken() {
  return $oauth2.hasAccessToken()
}

export function isGuest() {
  return $oauth2.isGuest()
}
export function getRefreshToken(clientId) {
  if (clientId && $oauth2.hasRefreshToken()) {
    const body = {
      'grant_type': 'refresh_token',
      'scope': 'customer-access',
      'refresh_token': $oauth2.refreshToken(),
      'client_id': clientId
    }
    const options = {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'accept': 'application/json; charset=utf-8',
        'content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      body: encoding.encodeComponent(body),
      dataType: 'text'
    }
    return fetch(`${$oauth2.appURL}/oauth2/token`, options).then(handleResponse).then(response => {
      return response.json().then(json => {
        $oauth2.alertResponse = null
        // nastaveni platnosti tokenu v cookies
        // const expires = new Date(new Date().getTime() + json.expires_in * 1000)
        // cookie.setValue($oauth2.rtenName(), $oauth2.token.refresh_token, { path: process.env.BASE_URL, expires: expires })
        $oauth2.expires.refresh = 0
        cookie.setValue($oauth2.rtenName(), json.refresh_token)
        return json
      })
    }).catch(error => {
      if (error.status === 401) {
        cookie.removeValue($oauth2.rtenName())
      }
      handleError(error)
    })
  }
}

export function getAccessToken(clientId, username, password, remember = true) {
  if (clientId && username && password) {
    const body = {
      'grant_type': 'password',
      'scope': 'customer-access',
      'username': username,
      'password': password,
      'remember_flag': remember,
      'client_id': clientId
    }
    const options = {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'accept': 'application/json; charset=utf-8',
        'content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      body: encoding.encodeComponent(body),
      dataType: 'text'
    }
    return fetch(`${$oauth2.appURL}/oauth2/token`, options).then(handleResponse).then(response => {
      return response.json().then(json => {
        $oauth2.alertResponse = null
        // nastaveni platnosti refresh tokenu v cookies pokud je zaskrtnuto remember
        if (remember) {
          // const expires = new Date(new Date().getTime() + json.expires_in * 1000)
          // cookie.setValue($oauth2.rtenName(), $oauth2.token.refresh_token, { path: process.env.BASE_URL, expires: expires })
          $oauth2.expires.refresh = 0
          cookie.setValue($oauth2.rtenName(), json.refresh_token)
        }
        return json
      })
    })
    .catch(handleError)
  }
}
